<template>
  <mobile-placeholder v-if="$vuetify.breakpoint.mobile" />
  <div v-else>
    <base-modal ref="confirm" />
    <router-view />
  </div>
</template>

<script>
  import BaseModal from '@/components/base/BaseModal'
  import MobilePlaceholder from '@/views/MobilePlaceholder'
  export default {
    name: 'App',
    components: {
      BaseModal,
      MobilePlaceholder,
    },
    mounted () {
      this.$root.$confirm = this.$refs.confirm.open
      this.$root.$confirm.$close = this.$refs.confirm.close
    },
  }
</script>
